import React, { useEffect, useState } from 'react'

// Ant design components
import { Button, message, Space, Tag, Tooltip } from 'antd'
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'

// Mobx
import { inject, observer } from 'mobx-react'

// Custom styles and components
import { blue, yellowPrimary } from '../../color'
import { ASSIGNEE_TYPE } from '../../constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { AvatarHasName } from '../../components/common/Avatar'
import { SelectList } from '../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled'
import {
  LableItem,
  ModalWrapper,
  TitleModal,
} from '../InternalDocumentIncoming/PopupHandleDocumentIncomingStyled'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TextField } from '@mui/material'
import utils from '../../utils'
import { SelectPeopleWrapper } from './DrawerWorkStyle'
import SelectUserButton from '../../components/SelectGroupPopup/SelectUserButton'
import SelectListComponent from '../../components/SelectGroupPopup/SelectListComponent'

const PopupAddPerson = props => {
  const {
    internalDocumentStore,
    loadingAnimationStore,
    selectPeopleStore,
    authenticationStore,
    workStore,
    open,
    handleClose,
    voteStore,
  } = props

  const { workDetail } = workStore
  const { selectedInternalDocumentOutgoing } = internalDocumentStore
  const {
    selectUserData,
    selectDepartmentData,
    assigneePopupType,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    clearSelected,
  } = selectPeopleStore

  const { currentUser } = authenticationStore
  const { assignees, title, code } = workDetail
  const { voteDetail } = voteStore

  const [voterList, setVoterList] = useState([])
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (open && assigneePopupType && voteDetail && !isInitialized) {
      setVoterList([
        ...selectUserData[assigneePopupType],
        ...selectDepartmentData[assigneePopupType],
      ])
      setIsInitialized(true)
    }
  }, [
    open,
    assigneePopupType,
    voteDetail,
    selectUserData,
    selectDepartmentData,
    isInitialized,
  ])

  useEffect(() => {
    if (!open) setIsInitialized(false)
  }, [open])

  const handleSubmitSelectUser = () => {
    const updatedVoterList = [
      ...selectUserData[assigneePopupType],
      ...selectDepartmentData[assigneePopupType],
    ]
    setVoterList(updatedVoterList)
    setIsVisibleSelectUserDepartmentPopup(false)
  }

  const handleSubmit = async () => {
    setIsVisibleSelectUserDepartmentPopup(false)

    const handlerList = assignees.filter(
      el =>
        el.permission === ASSIGNEE_TYPE.HANDLER &&
        el.assignee_code !== 'admin' &&
        el.assignee_type === 'USER'
    )

    const newVoterList = voterList.map(voter => ({ assignee_code: voter.id }))
    const newHandlerList = voterList
      .map(voter => ({ ...voter, assignee_code: voter.id }))
      .filter(
        voter =>
          !handlerList.some(
            handler => handler.assignee_code === voter.assignee_code
          )
      )

    const remove_items = voteDetail
      .map(voter => ({ assignee_code: voter.assignee_code }))
      .filter(
        prev =>
          !newVoterList.some(
            voter => voter.assignee_code === prev.assignee_code
          )
      )
    const new_items = newVoterList.filter(
      voter =>
        !voteDetail.some(prev => prev.assignee_code === voter.assignee_code)
    )

    const data = {
      document_code: code,
      document_title: title,
      type: 'WORK',
      vote_users: {
        remove_items: remove_items,
        new_items: new_items,
      },
      current_assignee: handlerList.concat(newHandlerList),
    }

    if (
      data.vote_users.new_items.length > 0 ||
      data.vote_users.remove_items.length > 0
    ) {
      try {
        await voteStore.createVote(data)
        await voteStore.getVoteDetail(code)
        await workStore.getWorkDetail(code)
        message.success('Bạn đã chọn người lấy ý kiến!')
      } catch (err) {
        message.error(err?.vi || 'Đã có lỗi xảy ra')
      }
    } else message.error('Bạn chưa chọn người lấy ý kiến')
    handleClose()
  }

  return (
    <ModalWrapper
      closable={false}
      footer={null}
      title={
        <TitleModal>
          <span className={'title-modal'}>Chọn người lấy ý kiến</span>
          <Space>
            <Button
              danger
              onClick={() => {
                handleClose()
                clearSelected()
              }}>
              Hủy bỏ
            </Button>
            <Button type={'primary'} onClick={handleSubmit}>
              Đồng ý
            </Button>
          </Space>
        </TitleModal>
      }
      visible={open}>
      <SelectPeopleWrapper>
        <SelectUserButton
          handleOnClick={() => {
            setIsVisibleSelectUserDepartmentPopup(true)
            handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.USER)
          }}
        />
        <SelectListComponent userList={voterList} />
      </SelectPeopleWrapper>

      <SelectPeoplePopup
        disableSelectDepartment
        handleCancelSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        handleSubmitSelectUser={handleSubmitSelectUser}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
    </ModalWrapper>
  )
}

PopupAddPerson.propTypes = {}

export default inject(
  'internalDocumentStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'authenticationStore',
  'workStore',
  'voteStore'
)(observer(PopupAddPerson))
